module.exports = __webpack_public_path__ + "static/img/组_15210.9fbb8fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/组_15210.png
// module id = Y751
// module chunks = 1